import DegressionCurrencies from 'components/commons/currencies/degression/Currencies';

export default {
	'components.base.DegressionCurrencies': {
		factory: DegressionCurrencies,
		deps: [{ $ref: 'components.DegressionCurrencies' }],
	},
};
